import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import MuiDenseTable from "../../../common-utilities/core/mui-dense-table";
import { getTrendsHeader } from "./helper";
import { HOSTNAME, REPORT_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";

const ExpenseDashboard = ({
  tabIndex,
  filters,
  setFilters,
  dateRanges,
  slug,
  token,
  searchTrigger,
  isDownload,
  setIsDownload,
  setSearchTrigger,
}) => {
  const [data, setData] = useState({});
  const loadData = () => {
    let params = {};
    let payload = {};
    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }
    filters.selectedFilters.forEach((filter) => {
      if (filter.id !== "storeCode" && filter.id !== "format" && filter.id !== "storeOpeningDate") {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          params[filter.id] = filter?.value?.map((v) => v.value || v);
        } else if (filter.value) {
          params[filter.id] = filter.value.value || filter.value;
        }
      }
      if (filter.id === "storeCode" || filter.id === "format") {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter?.value?.map((v) => v.value || v);
        } else if (filter.value) {
          payload[filter.id] = filter.value.value || filter.value;
        }
      }
      // special handling for storeOpeningDate - pass object directly to payload
      if (filter.id === "storeOpeningDate" && typeof filter.value === "object" && filter.value !== null) {
        if (filter.value.startDate && filter.value.endDate) {
          payload[filter.id] = filter.value;
        }
      }
    });
    if (tabIndex === 4 || tabIndex === 5) {
      if (filters?.expenseItem) {
        params["expenseItem"] = filters.expenseItem;
      }
    }
    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.EXPENSE_DASHBOARD}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setData(response);
        }
      })
      .catch((err) => {});
    if (searchTrigger) {
      setSearchTrigger(false);
    }
  };

  useEffect(() => {
    if (tabIndex === 4) {
      loadData();
    }
  }, [searchTrigger]);
  useEffect(() => {
    if (isDownload && tabIndex === 4) {
      loadData();
      setIsDownload(false);
    }
  }, [isDownload]);
  return (
    <Box sx={{ p: 2 }}>
      {Object.keys(data).length > 0 ? (
        Object.keys(data)?.map((region, index) => {
          const dataList = data[region]?.map((row) => {
            const flatRow = { ...row, showNow: true };

            ["MTD", "QTD", "YTD"].forEach((group) => {
              if (row[group] && Array.isArray(row[group])) {
                row[group].forEach((item) => {
                  flatRow[`${group}-${item.key}`] = item.value;
                });
              }
            });

            return flatRow;
          });

          const columnsList = getTrendsHeader(data[region], region);

          return (
            <Box key={index} sx={{ mb: 5 }}>
              <MuiDenseTable dataList={dataList} columnsList={columnsList} />
            </Box>
          );
        })
      ) : (
        <Typography variant="h4" textAlign="center" mt={5}>
          No data found
        </Typography>
      )}
    </Box>
  );
};

export default ExpenseDashboard;
